module.exports = __webpack_public_path__ + "img/entrepreneurs_flatline.1ac313af.svg";